import { Component } from "@angular/core";
import { CameraService } from "../services/camera.service";
import { CovidTestData } from "./covid-test.component";

@Component({
    selector: 'app-covid-test-container',
    template: `
        <app-covid-test (covidTestEvent)="handleCovidTestData($event)"></app-covid-test>
        <button class="btn btn-success" (click)="save()">Save</button>
    `
  })
export class CovidTestContainerComponennt{
    private covidTestFormResponse: CovidTestData;

    constructor(private cameraService: CameraService){}

    handleCovidTestData(covidTestData) {
        console.log('container component', covidTestData);
        this.covidTestFormResponse = covidTestData;
    }

    save(){
        console.log('CovidTestContainerComponennt.save',this.covidTestFormResponse);
        this.cameraService.saveCovidTestData(this.covidTestFormResponse).subscribe();
    }
}